import { Component, OnInit, OnDestroy } from '@angular/core';

import { Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

import { ShipmentService } from '../shipment.service';
import { EnumsService, Preferences } from '@library/core/services';

@Component({
   selector: 'shipment-risks',
   templateUrl: './risks.component.html',
   styleUrls: ['./risks.component.scss']
})
export class RisksComponent implements OnInit, OnDestroy {

   _onDestroy: Subject<void> = new Subject();

   config;

   risks;
   isQuote: any;
   riskList: string[] = [ 'declared_value', 'insurance' ];

   constructor(
      public shipment: ShipmentService,
      public enums: EnumsService,
      private prefs: Preferences,
   ) { }

   ngOnInit() {
      this.shipment.shipmentUpdate$.pipe(
         map(() => this.shipment.shipmentForm),
         takeUntil( this._onDestroy ),
      ).subscribe( shipmentForm => {
         this.isQuote = shipmentForm.get('isQuote');
         this.risks = shipmentForm.get( 'risks' );

         const amount = this.risks.get( 'amount' );
         const currency = this.risks.get( 'currency' );
         const type = this.risks.get( 'type' );

         if ( this.isQuote.value ) {
            this.riskList = [ 'insurance' ];
            if(type.value == "declared_value"){
               type.reset();
               amount.reset();
               currency.reset();
            }

         }

         this.risks.get( 'type' ).valueChanges.pipe(
            takeUntil( this._onDestroy ),
         ).subscribe( value => {
            if ( value ) {
               amount.enable();
               currency.enable();
               currency.setValue( currency.value ?? this.prefs.getPref( 'currency' ));
            } else {
               amount.disable();
               currency.reset();
               currency.disable();
            }
         });

         this.config = this.shipment?.configs?.risks;
      });
   }

   ngOnDestroy() {
      this._onDestroy.next();
      this._onDestroy.complete();
   }
}
